import { ReactNode } from 'react'
import * as Styled from './styled'

interface IButtonProps {
  onClick: () => void
  children: ReactNode
  variant?: 'primary' | 'secondary' | 'danger'
  disabled?: boolean
}

export const Button = ({
  onClick,
  children,
  variant = 'primary',
  disabled
}: IButtonProps) => {
  return (
    <Styled.StyledButton
      onClick={onClick}
      $variant={variant}
      disabled={disabled}
    >
      {children}
    </Styled.StyledButton>
  )
}
